export default {
  BEHAVIORAL_HEALTH_PARAGRAPH_ONE:
    'Behavioral Health can see patients 18+ with mild to moderate cases of the following conditions:',
  BEHAVIORAL_HEALTH_CONDITIONS: [
    'Anxiety',
    'Depression',
    'Attention Deficit',
    'Stress',
    'Addiction or Substance Misuse/Abuse',
    'Bipolar',
    'Anger or Mood Swings',
    'Panic Attacks',
    'Insomnia',
    'PTSD',
    'Grief',
    'Trauma'
  ],
  BEHAVIORAL_HEALTH_PARAGRAPH_TWO:
    "If your needs are urgent or you feel like you are in crisis, please call 988 to be connected to America's Suicide Prevention and Mental Health Crisis Lifeline or visit your nearest Emergency Room. Online scheduling is for routine, non-urgent behavioral health appointments.",
  BEHAVIORAL_HEALTH_PARAGRAPH_THREE:
    'If you select a same-day visit please expect a call from our Patient Services Representative to complete your check-in process. Depending on your patient status and any change in insurance, we may request you complete and return informational forms prior to your visit.'
};
